/**
 * typeguard for undefined values in array --> https://stackoverflow.com/questions/43118692/typescript-filter-out-nulls-from-an-array
 */
export const notEmpty = <TValue>(
  value: TValue | null | undefined,
): value is TValue => {
  return value !== null && value !== undefined;
};

// We need to use any here for generics
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type GenericFunction<T = any> = (...args: Array<any>) => T;
